/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Empty_StateInputs */



/**
* | output |
* | --- |
* | "No items found" |
*
* @param {Explorer_Thumbnail_Empty_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_empty_state = /** @type {((inputs?: Explorer_Thumbnail_Empty_StateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Empty_StateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun element trouve")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Artikel gefunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun elemento trovato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Товары не найдены")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron artículos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到任何物品")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アイテムが見つかりません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई आइटम नहीं मिला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum item encontrado")
	return /** @type {LocalizedString} */ ("No items found")
});